/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_TitleInputs */

const vi_dashboard_manager_title = /** @type {(inputs: Dashboard_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng quan`)
};

/**

* @param {Dashboard_Manager_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_title = /** @type {((inputs?: Dashboard_Manager_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_title(inputs)
});